import Skeleton from '@mui/material/Skeleton';

type DynamicIconSkeletonProps = {
  width?: number;
  height?: number;
};

export const DynamicIconSkeleton = ({ width = 20, height = 20 }: DynamicIconSkeletonProps) => {
  return <Skeleton variant="circular" sx={{ width, height, minWidth: width, minHeight: height }} />;
};
